module.exports = __webpack_public_path__ + "img/bpx-touchscreen.25766687.png";